import {
  Crown, Target, Shield, Crosshair, Zap, Flame,
  CalendarCheck, Star, Users, Award, Medal,
} from "lucide-react";

export const BADGE_ICONS = {
  Crown, Target, Shield, Crosshair, Zap, Flame,
  CalendarCheck, Star, Users, Award, Medal,
};

const TONE_MAP = {
  amber: { text: "text-amber-400", chip: "bg-amber-500/10 border-amber-500/30", ring: "shadow-amber-500/20" },
  emerald: { text: "text-emerald-400", chip: "bg-emerald-500/10 border-emerald-500/30", ring: "shadow-emerald-500/20" },
  cyan: { text: "text-cyan-400", chip: "bg-cyan-500/10 border-cyan-500/30", ring: "shadow-cyan-500/20" },
  rose: { text: "text-rose-400", chip: "bg-rose-500/10 border-rose-500/30", ring: "shadow-rose-500/20" },
  violet: { text: "text-violet-400", chip: "bg-violet-500/10 border-violet-500/30", ring: "shadow-violet-500/20" },
  orange: { text: "text-orange-400", chip: "bg-orange-500/10 border-orange-500/30", ring: "shadow-orange-500/20" },
  blue: { text: "text-blue-400", chip: "bg-blue-500/10 border-blue-500/30", ring: "shadow-blue-500/20" },
};

export function toneClasses(tone) {
  return TONE_MAP[tone] || TONE_MAP.emerald;
}

export function BadgeIcon({ icon, className }) {
  const Ico = BADGE_ICONS[icon] || Medal;
  return <Ico className={className} />;
}
